export const COMMON_BUILDING_MAX_DAMAGE = 2;
export const SPECIAL_BUILDING_MAX_DAMAGE = 2;
export const FORTRESS_MAX_DAMAGE = 10;
// Отношение урона, которое наносит отряд, атакующий крепость,
// к количеству повреждений, которые получает крепость.
// Остаток от деления отбрасывается.
// Обороняющийся отряд получает количество урона, равное количеству повреждений, полученных крепостью.
export const FORTRESS_DAMAGE_RATIO = 3;
